// @flow
import type { ID, AppState, Selector } from '../../core/types'
import type { Auction } from './types'
import type { Item } from '../item/types'
import { createSelector } from 'reselect'
import { domains } from '../constants'
import { getById, getDomain } from '../../modules/entities'
import { hget } from '../../modules/hash'
import { AUCTION_DETAIL_MODAL } from './constants'

export const getAuction = (id: ID): Selector<Auction> =>
  getById(domains.AUCTIONS, id)

export const getAuctionItems = (id: ID): Selector<Item[]> =>
  createSelector(
    getAuction(id),
    getDomain(domains.ITEMS),
    (auction: Auction, allItems: { [ID]: Item }): Item[] =>
      (auction.items || []).map(id => allItems[id])
  )

export const getAuctionModalType = (state: AppState): string =>
  hget(AUCTION_DETAIL_MODAL, 'isOpen', state)

export const isAuctionDetailModalOpen = (state: AppState): boolean =>
  Boolean(getAuctionModalType(state))



// WEBPACK FOOTER //
// ./src/services/auction/selectors.js